import { Outlet } from "react-router-dom";
import { Toolbar } from "primereact/toolbar";

import { Sidebar, ToolbarEndContent, ToolbarStartContent } from "./components";
import { useEffect } from "react";
import { useAppDispatch } from "store/store";
import { setUserProfile } from "store/slicer/ProfiloSlice";
import { getDecodedToken, getTokenFromStorage } from "utils";

export const Account = () => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    const token = getTokenFromStorage();
    const decodedToken = getDecodedToken();
    if (decodedToken) {
      dispatch(
        setUserProfile({
          token: token,
          firstName: decodedToken?.firstName,
          lastName: decodedToken?.lastName,
          email: decodedToken?.userName,
          role: decodedToken?.role,
        })
      );
    }
  }, [dispatch]);
  return (
    <div className="main-container">
      <Toolbar
        start={ToolbarStartContent}
        end={ToolbarEndContent}
        className="toolbar-dashboard"
      />
      <div className="main-container-body">
        <Sidebar />
        <div className="main-content">
          <Outlet />
        </div>
      </div>
    </div>
  );
};
